import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const Alert: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16.6195C12.4183 16.6195 16 13.0378 16 8.61951C16 4.20123 12.4183 0.619507 8 0.619507C3.58172 0.619507 0 4.20123 0 8.61951C0 13.0378 3.58172 16.6195 8 16.6195ZM8.91229 10.5669L9.10618 3.43769H6.89382L7.09268 10.5669H8.91229ZM7.15732 13.4008C7.39264 13.6328 7.67436 13.7488 8.00249 13.7488C8.21461 13.7488 8.41016 13.6957 8.58913 13.5897C8.76811 13.4803 8.91229 13.3361 9.02166 13.1571C9.13435 12.9749 9.19235 12.7743 9.19567 12.5556C9.19235 12.2308 9.07138 11.9524 8.83274 11.7204C8.5941 11.4884 8.31735 11.3723 8.00249 11.3723C7.67436 11.3723 7.39264 11.4884 7.15732 11.7204C6.92199 11.9524 6.80599 12.2308 6.8093 12.5556C6.80599 12.8837 6.92199 13.1654 7.15732 13.4008Z"
        fill={color ? color : '#FF573E'}
      />
    </svg>
  );
};

export default Alert;
